export const DateTimeFormat = {
  DATETIME_NUMBER_WITHOUT_SEC: "dd/MM/yyyy HH:mm"
}